<script>
// import ciList from '@/components/ciList'
// import Vue2Filters from 'vue2-filters'
import filters from '@/utils/filters'
import * as formats from '@/utils/formats.js'
import * as api from '@/utils/api.js'
// import ciList from '@/components/LOT/ciList'
import catalogItem from '@/components/LOT/catalogItem'
import ciAvailability from '@/components/LOT/ciAvailability'
import PhoneButton from '@/components/button-phone.vue'
export default {
  name: 'library-of-things',
  components: {
    catalogItem,
    ciAvailability: () => import('@/components/LOT/ciAvailability'),
    PhoneButton,
  },
  data: () => ({
    availabilityItem: null,
    categories: [],
    isLoading: true,
    catalogItems: [],
    filterCategory: [],
    filterSearch: null,
  }),
  computed: {
    categoriesAvailable() {
      const categories = []
      this.catalogItems.forEach((i) => categories.push(i.category))
      return [...new Set(categories)]
        .map((c) => this.categoriesById[c])
        .sort((a, b) => a.name.localeCompare(b.name))
    },
    categoriesById() {
      const categories = {}
      this.categories.forEach((cat) => {
        categories[cat.id] = cat
      })
      return categories
    },
    itemList() {
      let cItemsFiltered = []
      // this.catalogItems.forEach(ci => {
      //   cItemsFiltered.push(this.formatCatalogItemData(ci))
      // })
      const filterNames = [
        'filterCategory',
        // 'filterRangeDate',
        'filterSearch',
      ]
      let filtersSet = {}
      filterNames.forEach((f) =>
        this[f] && this[f].length > 0 ? (filtersSet[f] = this[f]) : null,
      )

      if (Array.isArray(this.catalogItems)) {
        this.catalogItems.forEach((ci) => {
          cItemsFiltered.push(this.formatCatalogItemData(ci))
        })
      }

      if (Object.keys(filtersSet).length > 0) {
        //   if (filtersSet.filterAvailability) {
        //     cItemsFiltered = cItemsFiltered.filter(ci =>
        //       filtersSet.filterAvailability === 'available'
        //         ? ci.isAvailable
        //         : !ci.isAvailable
        //     )
        //   }
        if (filtersSet.filterCategory) {
          cItemsFiltered = cItemsFiltered.filter((ci) =>
            filtersSet.filterCategory.includes(ci.category),
          )
        }

        //   if (filtersSet.filterStatus) {
        //     cItemsFiltered = cItemsFiltered.filter(ci =>
        //       filtersSet.filterStatus.includes(ci.status.toUpperCase())
        //     )
        //   }

        if (filtersSet.filterSearch) {
          const possibleKeys = [
            'abbreviation',
            'categoryName',
            'description',
            'name',
            'status',
          ]
          cItemsFiltered = cItemsFiltered.filter((ci) => {
            return filters.findStringMatchesInObj(
              ci,
              possibleKeys,
              filtersSet.filterSearch,
            )
          })
        }
      }

      // if (filtersSet.filterVisibility) {
      //   cItemsFiltered = cItemsFiltered.filter(
      //     ci => ci.internal === filtersSet.filterVisibility
      //   )
      // }
      // return cItemsFiltered

      return cItemsFiltered?.sort((a, b) => a.name.localeCompare(b.name))
    },
  },
  methods: {
    formatCatalogItemData(catalogItem) {
      //format data to be passed to list item
      if (catalogItem && catalogItem.name) {
        const category = filters.categoryById(
          catalogItem.category,
          this.categories,
        )
        catalogItem.categoryName = category.name || 'MISC'
        if (catalogItem.lastReservation && catalogItem.lastReservation['0']) {
          let now = new Date()
          catalogItem.isAvailable = !filters.testRangeOverlap(
            catalogItem.lastReservation['0'].start_date,
            catalogItem.lastReservation['0'].end_date,
            now,
            now,
          )
        } else {
          catalogItem.isAvailable = true
        }
        return formats.catalogItem(catalogItem)
      } else {
        return formats.catalogItem(catalogItem)
      }
    },
    // onCheckAvailability(item) {
    //   this.modalCompData = { categoriesById: this.categoriesById, item }
    // }
  },
  async created() {
    const expectedItems = ['catalogItems', 'categories']
    const items = await api.get('lot')
    console.log(items)
    for (const expectedItem of expectedItems) {
      if (items[expectedItem]) {
        this[expectedItem] = [...items[expectedItem]]
      }
    }
    this.isLoading = false
  },
}
</script>

<template>
  <v-container class="d-flex flex-column align-center mb-12 rounded-lg">
    <h1 class="text-h2 text-center primary--text font-weight-bold">
      Library of Things
    </h1>
    <v-dialog
      :value="!!availabilityItem?.id"
      max-width="500"
      persistent
      transition="dialog-transition"
    >
      <ci-availability
        v-if="!!availabilityItem?.id"
        :categoriesById="categoriesById"
        :item="availabilityItem"
        @close="availabilityItem = null"
      ></ci-availability>
    </v-dialog>
    <!-- <img height="200px" width="200px" src="https://media.eipl.org/site/images/services/library-of-things.png" class="my-4 rounded" /> -->
    <v-row justify="center">
      <v-col cols="12" lg="10" xl="8" class="px-0 px-sm-3">
        <v-card class="mt-16">
          <v-card-text class="d-flex flex-column align-start primary--text">
            <p class="text-body-1 primary--text font-weight-black mb-1">
              The library has a collection of items that patrons may borrow for
              home use.
            </p>
            <p class="primary--text text--lighten-2 font-weight-bold mb-0">
              To borrow, patrons must be at least 18 years old and have an Adult
              library card from the East Islip Public Library that is in good
              standing.
            </p>
            <v-card flat width="100%" class="primary--text mt-1">
              <v-card-title class="pb-0">
                <v-avatar color="#088f25" size="19" class="mr-2"></v-avatar>
                <p class="text-body-1 font-weight-bold mb-0">Lawn Games</p>
              </v-card-title>
              <v-card-text class="primary--text pt-0">
                <ul class="text-body-2 font-weight-normal">
                  <li>May be borrowed for up to 3 days with no renewals</li>
                  <li>Two games per household may be borrowed.</li>
                </ul>
              </v-card-text>
            </v-card>
            <v-card flat width="100%" class="primary--text mt-1">
              <v-card-title class="pb-0">
                <v-avatar color="#ff8508" size="19" class="mr-2"></v-avatar>
                <p class="text-body-1 font-weight-bold mb-0">
                  Library Equipment
                </p>
              </v-card-title>
              <v-card-text class="primary--text pt-0">
                <ul class="text-body-2 font-weight-normal">
                  <li>May be borrowed for up to 14 days with no renewals.</li>
                  <li>Two items per household may be borrowed.</li>
                </ul>
              </v-card-text>
            </v-card>
            <v-card flat width="100%" class="primary--text mt-1">
              <v-card-title class="pb-0">
                <v-avatar color="#f80a0a" size="19" class="mr-2"></v-avatar>
                <p class="text-body-1 font-weight-bold mb-0">WiFi Hotspots</p>
              </v-card-title>
              <v-card-text class="primary--text pt-0">
                <ul class="text-body-2 font-weight-normal">
                  <li>
                    May be borrowed for up to 14 days in one month per household
                    with not more than two reservations in a one-month period.
                  </li>
                  <li>
                    No renewals are permitted. Only one hotspot per household
                    may be borrowed at a time.
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-actions class="d-flex flex-column align-start flex-wrap">
            <p class="text-body-1 font-weight-bold primary--text mb-0">
              For reservations please call the library.
            </p>
            <phone-button class="mt-4" />
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" lg="10" xl="8" class="px-0 px-sm-3">
        <v-card class="d-flex flex-column justify-start" height="100%">
          <v-card-text class="pa-6">
            <!--CATEGORY SELECT -->
            <v-select
              v-model="filterCategory"
              :items="categoriesAvailable"
              item-text="name"
              item-value="id"
              label="Category"
              attach="#mm"
              multiple
              :menu-props="{
                absolute: true,
                bottom: true,
                'min-width': '100%',
              }"
              chips
              full-width
              deletable-chips
              no-hint
              no-title
              clearable
              color="primary"
              class="pt-0"
            >
              <!--CATEGORY SELECT ITEM -->
              <template v-slot:item="{ item }">
                <v-list-item-icon>
                  <v-icon
                    v-text="
                      filterCategory.includes(item.id)
                        ? 'mdi-checkbox-marked'
                        : 'mdi-checkbox-blank-outline'
                    "
                  ></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.name"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon
                    :color="item.color"
                    v-text="'mdi-checkbox-blank-circle'"
                  ></v-icon>
                </v-list-item-action>
              </template>
              <template v-slot:selection="{ item }">
                <v-chip
                  :color="item.color"
                  close
                  @click:close="
                    filterCategory = filterCategory.filter((i) => i !== item.id)
                  "
                  class="white--text font-weight-bold"
                >
                  <span>{{ item.name }}</span>
                </v-chip>
              </template>
            </v-select>
            <v-text-field
              solo
              rounded
              clearable
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              color="primary"
              class="flex-grow-0 flex-shrink-1"
              v-model="filterSearch"
            ></v-text-field>

            <v-sheet id="mm" height="10" width="100%"></v-sheet>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="10" xl="8" class="text-center px-0 px-sm-3">
        <v-progress-circular
          v-if="isLoading"
          indeterminate
        ></v-progress-circular>
        <v-expansion-panels popout class="rounded-lg my-1">
          <transition-group name="flip-list" mode="out-in" style="width: 100%">
            <catalogItem
              v-for="item in itemList"
              :key="item.id"
              :item="item"
              :categoriesById="categoriesById"
              @checkAvailability="availabilityItem = item"
              class="mt-2 mt-sm-1"
            ></catalogItem>
          </transition-group>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped></style>
